export default {
  apiAuth: {
    profileServicesAuthVIZIO: 'Basic dml6aW86UUFNdCFSaz1SZG1wOUU7eQ==',
    profileServicesAuthComcast: 'Basic Y29tY2FzdHgxOmdpZlNhWWJacWtJbm01dDQ=',
    profileServicesAuthSamsung:
      'Basic a2lkc3NhbXN1bmd0djpLbUEzN0UyVkRkb0wxR3JCcEllWQ==',
    profileServicesAuthLG: 'Basic bGd0djpjemM1SEJBKmJlaDRreWcxcWRj',
    contentServicesAuth: 'Basic a2lkc3NhbXN1bmd0djpCQ1hiQTV2SXhqOFNGNnY=',
    localizationServiceAuth: 'Basic b3R0ZXI6dk10ViFLUGdKYnltZjdqWg==',

    //Production
    mvaultServicesAuth: 'Basic Vzg0SXFsWkx0bmF6Qmc2QTpCeHhkVHl1R1Z1RHVBekEw',
    //Staging
    //mvaultServicesAuth: 'Basic SUxCVm9FUjZmTFVPWmhNZzpwZEY1ODJrWlZFckJYczBr',
  },
  apiUrls: {
    stationDetails:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/screens/stations/[STATION_ID]/',
    stationsByAuto: 'https://localization.services.pbs.org/localize/v2/auto/',
    localizeStations: 'https://localization.services.pbs.org/localize/v3/auto/',
    localizationCodeService:
      'https://localization.services.pbs.org/localize/auth/v1/code/',
    stationsByIp: 'https://localization.services.pbs.org/localize/ip/[IP]/',
    stationsByZip:
      'https://localization.services.pbs.org/localize/zipcode/[ZIP]/',
    favoriteStations:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/profile/[UID]/collections/favorite-stations/',
    deviceActivationStatus:
      'https://profile.services.pbs.org/v1/matchmaker/devices/[deviceId]/app/ga/',
    generateAuthCode:
      'https://profile.services.pbs.org/v1/matchmaker/authCode/',
    getUserFavorites:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/profile/[uid]/collections/favorite-shows/',
    getUserWatchlist:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/profile/[uid]/collections/watchlist/',
    getUserHistory:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/profile/[uid]/collections/viewing-history/',
    getWatchProgress:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/profile/[uid]/collections/viewing-history/[videoId]/',
    getUserInfo:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/profile/[uid]/',
    getUserMembershipStations:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/profile/[UID]/collections/user-membership-stations/',
    getUpNext:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/screens/video-assets/[videoId]/up-next/?user_id=[uid]&upsell=true',
    deviceDeactivation:
      'https://profile.services.pbs.org/v1/users/[UID]/registeredDevice/[deviceId]/?app=ga',
    stationShowMenu:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/collections/station-show-menu/?station_id=[STATION_ID]',
    privacyPolicyText:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/collections/privacy-policy/',
    closedCaptionText:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/collections/closed-captioning/',
    termsOfUseText:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/collections/terms-of-use/',
    search:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/screens/search/?station_id=[STATION_ID]&q=[QUERY]',
    setStation:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/profile/[UID]/collections/favorite-stations/[GUID]/',
    checkPassportStatus:
      'https://tvault.services.pbs.org/api/v1/[STATION_ID]/customers/check-passport/[PID]/', //@TODO: Update this with PROD URL
    activatePassport:
      'https://mvault.services.pbs.org/api/memberships/by_mvault_id/[MVAULT_ID]/',
    getInAppDonationsEligibility:
      'https://tvault.services.pbs.org/api/v1/[STATION_ID]/campaigns/?filter%5Bactive_period%5D=[ACTIVE_PERIOD]&filter%5Bplatforms%5D=[PLATFORMS]&filter%5Bpassport_enabled%5D=[PASSPORT_ENABLED]', //@TODO: Update this with PROD URL
    setTransactionDonation:
      'https://tvault.services.pbs.org/api/v1/[STATION_ID]/transactions/',
    setSubscriptionDonation:
      'https://tvault.services.pbs.org/api/v1/[STATION_ID]/subscriptions/',
    getTransactionDonationStatus:
      'https://tvault.services.pbs.org/api/v1/[STATION_ID]/transactions/[DONATION_ID]/',
    getSubscriptionDonationStatus:
      'https://tvault.services.pbs.org/api/v1/[STATION_ID]/subscriptions/[DONATION_ID]/',
    getConsentPayload:
      'https://tvault.services.pbs.org/api/v1/payment-gateways/xfinity/consent-payload/',
    cancelDonation:
      'https://tvault.services.pbs.org/api/v1/[STATION_ID]/subscriptions/[DONATION_ID]/',
    getDonationInformation:
      'https://tvault.services.pbs.org/api/v1/subscriptions/xfinity/[PID]/',
    getMessageInformation:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/messages/',
    evergreenMessaging:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/app-banner/',
  },
  contentUrls: {
    getShows:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/screens/shows/?station_id=[STATION_ID]',
    getShowInfo:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/screens/shows/[slug]/?station_id=[STATION_ID]',
    getShowInfoByUser:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/screens/shows/[slug]/?user_id=[USER_ID]',
    changeFavorites:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/profile/[uid]/collections/favorite-shows/[cid]/',
    changeWatchlist:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/profile/[uid]/collections/watchlist/[cid]/',
    getAvailableSeasons:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/screens/shows/[slug]/seasons/?limit=100&start=0&station_id=[STATION_ID]',
    getExtrasInSeasons:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/screens/shows/[slug]/seasons/[SEASON_ID]/assets/?station_id=[STATION_ID]',
    getPaginatedEpisodes:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/screens/shows/[slug]/seasons/[SEASON_ID]/episodes/?station_id=[STATION_ID]',
    getSeasonDetails:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/screens/shows/[slug]/seasons/[SEASON_ID]/?station_id=[STATION_ID]',
    getHomeData:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/screens/home/?station_id=[STATION_ID]',
    getMoreExtras:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/screens/shows/[slug]/assets/?station_id=[STATION_ID]',
    getSchedules:
      'https://content.services.pbs.org/v3/[DEVICETYPE]/schedules/livestreams/?station_id=[STATION_ID]&date=[DATE]&all_livestreams=[ALL_LIVESTREAMS]',
  },
  featureTogglesBaseURL: {
    dev: 'https://fmac.edcar.pbs.org/api/',
    prod: 'https://fmac.pbs.org/api/',
  },
  deeplinkPatterns: {
    video:
      '/video-details/https%3A%2F%2Fcontent.services.pbs.org%2Fv3%2Fviziotv%2Fscreens%2Fvideo-assets%2F{{videoId}}%2F',
    show: '/show-details/{{seriesId}}',
  },
  advertising: {
    muxPropertyKey: 'sh1cu4rhemjbphkph1bvpjsji',
  },
  tvKeys: {
    13: 'ENTER',
    19: 'PAUSE',
    37: 'LEFT',
    38: 'UP',
    39: 'RIGHT',
    40: 'DOWN',
    48: 'N0',
    49: 'N1',
    50: 'N2',
    51: 'N3',
    52: 'N4',
    53: 'N5',
    54: 'N6',
    55: 'N7',
    56: 'N8',
    57: 'N9',
    403: 'RED',
    404: 'GREEN',
    405: 'YELLOW',
    406: 'BLUE',
    412: 'RW',
    413: 'STOP',
    415: 'PLAY',
    416: 'REC',
    417: 'FF',
    427: 'CH_UP',
    428: 'CH_DOWN',
    447: 'VOL_DOWN',
    448: 'VOL_UP',
    449: 'MUTE',
    457: 'INFO',
    10009: 'BACK',
    10135: 'TOOLS',
    10182: 'EXIT',
    10190: 'PRECH',
    10252: 'PLAYPAUSE',
  },
  sentryDsns: {
    'otter-tizen-ga-prod.pbs.org':
      'https://9c327fc02b644458835af18d04d0db10@o260369.ingest.sentry.io/1465904',
    'otter-tizen-ga-staging.pbs.org':
      'https://ac7a86b149a94bc5898a226e714da487@o260369.ingest.sentry.io/1465903',
    'otter-vizio-ga-prod.pbs.org':
      'https://9c327fc02b644458835af18d04d0db10@o260369.ingest.sentry.io/1465904',
    'otter-vizio-ga-staging.pbs.org':
      'https://ac7a86b149a94bc5898a226e714da487@o260369.ingest.sentry.io/1465903',
    'otter-comcastx1-ga-prod.pbs.org':
      'https://9c327fc02b644458835af18d04d0db10@o260369.ingest.sentry.io/1465904',
    'otter-comcastx1-ga-staging.pbs.org':
      'https://ac7a86b149a94bc5898a226e714da487@o260369.ingest.sentry.io/1465903',
    'otter-browser-ga-prod.pbs.org':
      'https://9c327fc02b644458835af18d04d0db10@o260369.ingest.sentry.io/1465904',
    'otter-browser-ga-staging.pbs.org':
      'https://ac7a86b149a94bc5898a226e714da487@o260369.ingest.sentry.io/1465903',
    'otter-lgtv-ga-prod.pbs.org':
      'https://9c327fc02b644458835af18d04d0db10@o260369.ingest.sentry.io/1465904',
    'otter-lgtv-ga-staging.pbs.org':
      'https://ac7a86b149a94bc5898a226e714da487@o260369.ingest.sentry.io/1465903',
    defaults: '',
  },
  analytics: {
    browserAppId: 'GA Browser',
    samsungTrackingId: 'UA-34215043-13',
    samsungAppId: '3201809016951',
    vizioTrackingId: 'UA-34215043-28',
    vizioAppId: 'GA VIZIO',
    appName: 'PBS',
  },
  analytics4: {
    samsung: {
      measurementId: 'G-3L0FW27SLF',
      livestream_video_player: 'GA Samsung TV Livestream',
      livestream_video_title: 'Livestream',
    },
    vizio: {
      measurementId: 'G-XJTVBCCRJW',
      livestream_video_player: 'GA VIZIO TV Livestream',
      livestream_video_title: 'Livestream',
    },
    comcast: {
      measurementId: 'G-JKQF8B8P7T',
      livestream_video_player: 'GA Comcast TV Livestream',
      livestream_video_title: 'Livestream',
    },
    webOS: {
      measurementId: 'G-Z510TMD9BK',
      livestream_video_player: 'GA LG TV Livestream',
      livestream_video_title: 'Livestream',
    },
    xumo: {
      livestream_video_player: 'GA Xumo TV Livestream',
      livestream_video_title: 'Livestream',
    },
  },
  stationByIpDefault: '198.7.59.119',
  analyticsCampaignParams: {
    utm_campaign: 'campaignName',
    utm_source: 'campaignSource',
    utm_medium: 'campaignMedium',
    utm_term: 'campaignKeyword',
    utm_content: 'campaignContent',
    utm_id: 'campaignId',
  },
}
